import { render, staticRenderFns } from "./svg_config.vue?vue&type=template&id=b2ba9230&"
import script from "./svg_config.vue?vue&type=script&lang=js&"
export * from "./svg_config.vue?vue&type=script&lang=js&"
import style0 from "./svg_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports